import { render } from "./AdminInquiries.vue?vue&type=template&id=70f670d4"
import script from "./AdminInquiries.vue?vue&type=script&lang=js"
export * from "./AdminInquiries.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__